import { request } from "../request";

/**
 * 获取API产品列表
 */
export function fetchGetAiProductListAsync() {
    return request<(DB.AiProduct & { UseCount: number })[]>({
        url: '/AiProduct/GetAiProductList',
        method: 'get'
    })
}